module.exports = __webpack_public_path__ + "resources/img/img-vormetric-encryption-jp.7fb3fc676f61e4eef96047084b13e5d3.png";